module.exports = {
  "country": "AU",
  "artist": "Dami In",
  "song": "Sounds of Silence",
  "year": "2016",
  "place": "2",
  "spotify": "2b9czDPSLTI88694CIqCy3"
};